import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from '@/src/store'
import { useAuth } from '@/src/hooks/useAuth'
import { resolveFeatures } from '@/src/store/apps/featureExperience'
import { DEFAULT_FEATURE_RESOLVE_KEYS } from '@/src/constants/featureExperience'
import type { FeatureKey } from '@/src/constants/featureExperience'

// LEGACY_MATERIAL_NAV: default resolve includes sidebar_navigation; trim keys when BE drops classic nav.

interface FeatureExperienceProviderProps {
  children: React.ReactNode

  /** Defaults to sidebar_navigation; extend when new experiences ship. */
  featureKeys?: FeatureKey[]

  /** Thread from app context when restaurant-scoped pilot rules apply. */
  restaurantId?: string | number | null
}

export const FeatureExperienceProvider: React.FC<FeatureExperienceProviderProps> = ({
  children,
  featureKeys = DEFAULT_FEATURE_RESOLVE_KEYS,
  restaurantId
}) => {
  const dispatch = useDispatch<AppDispatch>()
  const { user } = useAuth()
  const restoIdFromStore = useSelector((s: RootState) => s.gyg365RestoList?.restoData?.id)
  const effectiveRestaurantId = restaurantId ?? restoIdFromStore ?? null
  const keysRef = useRef(featureKeys)
  keysRef.current = featureKeys

  useEffect(() => {
    if (!user) return
    dispatch(
      resolveFeatures({
        keys: [...keysRef.current],
        restaurantId: effectiveRestaurantId
      })
    )
  }, [user, dispatch, effectiveRestaurantId])

  return <>{children}</>
}
